import {
  Briefcase20Regular,
  Code20Regular,
  Megaphone20Regular,
  Money20Regular,
  PeopleTeam20Regular,
  ShoppingBag20Regular,
} from '@/components/Icon'

/**
 * Personas the composer offers, named by department. The trigger renders the
 * label alone (no leading icon) on the landing screen; the icons are for the
 * menu rows.
 *
 * @type {{ value: string, label: string, Icon: import('react').ComponentType }[]}
 */
export const HOME_PERSONA_SELECT_OPTIONS = [
  { value: 'sales', label: 'Sales', Icon: ShoppingBag20Regular },
  { value: 'engineering', label: 'Engineering', Icon: Code20Regular },
  { value: 'finance', label: 'Finance', Icon: Money20Regular },
  { value: 'operations', label: 'Operations', Icon: Briefcase20Regular },
  { value: 'people', label: 'People', Icon: PeopleTeam20Regular },
]
